import axios from 'axios'

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  response => response.data,
)

export default {
  verifyEmail(email, data) {
    return axiosInstance.post(`api/emails/${email}/verify`, data)
  },
}
